<template>
    <div v-if="filterData.length > 0">
        <line-chart-index
            :chart-data="chartData"
            :max-y="allIndicesMax"
            :min-y="allIndicesMin"
            :index-type="indexType"
        ></line-chart-index>
        <div class="mt-4 flex justify-center" v-if="showLink">
            <div class="max-w-screen-sm">
                <a :href="params.link" class="btn secondary"
                    >View <i class="ml-1 fal fa-chart-line"></i
                ></a>
            </div>
        </div>
        <div class="mt-4 flex justify-center">
            <div class="flex-grow max-w-screen-sm">
                <div :class="'form-item select-single '" v-if="showRangeSelect">
                    <div class="flex">
                        <label>Date Range: </label>
                    </div>
                    <select v-model="dateRange" class="form-select single">
                        <option value="">-- Select --</option>
                        <option v-for="(year, index) in allYears" :value="year">
                            From {{ year }} to current
                        </option>
                    </select>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
function initialState() {
    return {
        isLoading: true,
        options: {},
        dateRange: "",
        defaultShowYears: 2,
    };
}
import { mapGetters } from "vuex";
import _map from "lodash/map";
import _uniq from "lodash/uniq";
import _filter from "lodash/filter";
import _max from "lodash/max";
import _min from "lodash/min";
export default {
    props: {
        indexType: {
            type: String,
            required: true,
            default: "",
        },
        data: {
            type: [Array, Object],
            required: true,
            default: () => {},
        },
        params: {
            type: [Array, Object],
            required: false,
            default: () => {},
        },
    },
    data() {
        return initialState();
    },
    mounted() {
        this.dateRange = this.defaultYear;
        this.$store.dispatch("fetchUser");
    },
    methods: {
        getYear(item) {
            return this.$dayjs(item.date).year();
        },
        checkDate(item) {
            return this.$dayjs(item.date).isSameOrAfter(
                this.$dayjs().year(this.dateRange),
                "year"
            );
        },
        getIndex(item) {
            return parseFloat(item.index);
        },
    },
    watch: {},
    computed: {
        ...mapGetters(["user"]),
        yScalePadding() {
            return this.indexType == "auction" ? 0.1 : 50;
        },
        allYears() {
            var raw = _map(this.data, this.getYear);
            var data = _uniq(raw);
            return data;
        },
        allIndices() {
            var raw = _map(this.data, this.getIndex);
            var data = _uniq(raw);
            return data;
        },
        allIndicesMax() {
            return _max(this.allIndices) + this.yScalePadding;
        },
        allIndicesMin() {
            return _min(this.allIndices) - this.yScalePadding;
        },
        defaultYear() {
            //return the starting year
            const yearCount = this.params.show_years
                ? this.params.show_years
                : this.defaultShowYears;
            return this.allYears.length > yearCount
                ? this.allYears[this.allYears.length - yearCount]
                : this.$dayjs().year();
        },
        filterData() {
            const cloneData = Object.assign({}, this.data);
            return _filter(cloneData, this.checkDate);
        },
        chartData() {
            //return this.data;
            var labels = _map(this.filterData, "date_formatted");
            var indices = _map(this.filterData, "index_formatted");
            return {
                labels: labels,
                datasets: [
                    {
                        label: "Index",
                        data: indices,
                    },
                ],
            };
        },
        showRangeSelect() {
            return this.params.show_range_select ? true : false;
        },
        showLink() {
            return this.params.show_link && this.params.link ? true : false;
        },
    },
};
</script>

<style lang="scss" scoped></style>
